import React from "react";
import LineChart from "./LineChart";
import { format } from "date-fns";
import MonthChoice from "./common/MonthChoice";
import StatChange from "./common/StatChange";
import { useNavigate } from "react-router-dom";
import Sites from "./Sites";
export default function Students({ stats, chartFormat, title, year, month, field=false }) {
  const navigate = useNavigate()
  const [months] = React.useState(1);
  /* const stats = months===1 ? stats.filter(s=>s.year===year && s.month===month+1) : stats.filter(
    (s) => new Date(s.date) > addMonths(new Date(), 0 - months)
  )
  stats.sort((a, b) =>
    new Date(a.date) > new Date(b.date)
      ? 1
      : new Date(b.date) > new Date(a.date)
      ? -1
      : 0
  ); */
  if (stats.length === 0) return <div style={{ height: 310, width:450,display:"flex", justifyContent:"center", alignItems:"center", color:"#ccc"}}>No data</div>
  return (
    <div style={chartFormat}>
      <div className="dflex-sb">
        <h3 style={{ marginLeft: 5, marginBottom: 0 }}>
          {title}: {stats[stats.length - 1].activeStudents}
        </h3>

        {/*   <MonthChoice months={months} setMonths={setMonths} /> */}
      </div>
      {field ? (
        <Sites
          stats={stats}
          field={field}
        />
      ) : (
        <div style={{ minHeight: 50 }}></div>
      )}
      {year === new Date().getFullYear() &&
      month === new Date().getMonth() + 1 ? (
        <StatChange
          stats={stats}
          stat={"activeStudents"}
        />
      ) : (
        <div style={{ height: 24 }}></div>
      )}
      <div
        style={{
          cursor: "pointer",
          height: 350,
          display: "flex",
          flexDirection: "column-reverse",
        }}
        onClick={() => {
          localStorage.setItem("newLostTabs", "0");
          navigate("/manage/newlost");
        }}
      >
        <LineChart
          labels={setLabels(stats, months)}
          lineData={stats.map((s) => s.activeStudents)}
          color="#02627a"
        />
      </div>
      {/*  <TextStats stats={stats} /> */}
    </div>
  );
}

function setLabels(stats, months) {
  let labels = [];
  switch (months) {
    case 1:
      labels = stats.map((s) => s.day);
      break;
    default:
      labels = stats.map((s) => format(new Date(s.date), "MMM"));
      break;
  }
  return labels;
}
